<div class="staff-messages-page">
  <div class="toolbar">
    <div>
      <h2>Mails</h2>
      <p class="subhead">Communication Hub email-style inbox and sent messages.</p>
    </div>
    <div class="toolbar-actions">
      <button mat-stroked-button *ngIf="canSendMessages()" (click)="toggleCompose()">{{ showCompose ? 'Close Compose' : 'Compose' }}</button>
      <button mat-flat-button color="primary" (click)="loadPage()">Refresh</button>
    </div>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div class="compose-card" *ngIf="showCompose">
    <h3>Compose Message</h3>
    <div class="form-grid">
      <mat-form-field appearance="outline">
        <mat-label>Subject</mat-label>
        <input matInput [(ngModel)]="form.subject" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="recipient-select">
        <mat-label>Recipients</mat-label>
        <mat-select multiple [(value)]="form.recipientStaffIds" [disabled]="form.sendToAllStaff">
          <mat-option *ngFor="let s of staffOptions" [value]="s.id">{{ s.fullName }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="body-field">
      <mat-label>Message Body</mat-label>
      <textarea matInput rows="4" [(ngModel)]="form.body"></textarea>
    </mat-form-field>

    <div class="attachment-row">
      <label class="file-picker">
        <mat-icon>attach_file</mat-icon>
        <span>{{ attachment ? attachment.name : 'Attach media/file' }}</span>
        <input type="file" accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx" (change)="onAttachmentSelected($event, 'compose')" />
      </label>
      <button mat-button type="button" *ngIf="attachment" (click)="removeAttachment('compose')">Remove</button>
    </div>

    <div class="compose-actions">
      <mat-slide-toggle [(ngModel)]="form.sendToAllStaff" [disabled]="!canSendGeneral()">
        Send to all staff (HR/Admin)
      </mat-slide-toggle>
      <button mat-flat-button color="primary" (click)="sendMessage()">Send Message</button>
    </div>
  </div>

  <div class="mail-layout">
    <aside class="mailboxes">
      <button class="mailbox-btn" [class.active]="activeMailbox === 'inbox'" (click)="setMailbox('inbox')">
        <mat-icon>inbox</mat-icon>
        <span>Inbox</span>
        <span class="count">{{ inboxUnreadCount() }}</span>
      </button>
      <button class="mailbox-btn" [class.active]="activeMailbox === 'sent'" (click)="setMailbox('sent')">
        <mat-icon>send</mat-icon>
        <span>Sent</span>
        <span class="count">{{ sent.length }}</span>
      </button>
    </aside>

    <section class="message-list-panel">
      <div class="list-header">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Search messages</mat-label>
          <input matInput [(ngModel)]="searchTerm" placeholder="Search subject, sender, body">
        </mat-form-field>
      </div>

      <div class="message-list" *ngIf="mailboxItems.length; else emptyList">
        <button
          type="button"
          class="message-row"
          *ngFor="let row of mailboxItems"
          [class.selected]="isSelected(row)"
          [class.unread]="activeMailbox === 'inbox' && !row.isRead"
          (click)="selectMessage(row)"
        >
          <div class="from-line">
            <span class="from">{{ senderLabel(row) }}</span>
            <span class="when">{{ formatWhen(row.createdAt) }}</span>
          </div>
          <div class="subject-line">
            <span class="subject">{{ row.subject }}</span>
            <span class="status-chip closed" *ngIf="row.isClosed">Closed</span>
          </div>
          <div class="preview">{{ row.body }}</div>
        </button>
      </div>
      <ng-template #emptyList>
        <div class="empty-list">No messages in this mailbox.</div>
      </ng-template>
    </section>

    <section class="conversation-panel" *ngIf="selectedMessage as msg; else emptyDetail">
      <div class="conv-header">
        <h3>{{ msg.subject }}</h3>
        <div class="conv-actions">
          <button mat-stroked-button color="warn" *ngIf="canSendMessages()" [disabled]="msg.isClosed" (click)="closeThread(msg)">
            Close Thread
          </button>
          <button mat-stroked-button *ngIf="activeMailbox === 'sent' && canSendMessages()" (click)="toggleManageRecipients()">
            {{ managingRecipients ? 'Close Members' : 'Manage Group' }}
          </button>
        </div>
      </div>

      <div class="conv-meta">
        <div><strong>{{ activeMailbox === 'inbox' ? 'From' : 'To' }}:</strong> {{ senderLabel(msg) }}</div>
        <div><strong>Date:</strong> {{ formatWhen(msg.createdAt) }}</div>
        <div><strong>Status:</strong> {{ msg.isClosed ? ('Closed' + (msg.closedByName ? (' by ' + msg.closedByName) : '')) : 'Open' }}</div>
      </div>

      <article class="message-body">{{ msg.body }}</article>
      <div class="attachment-preview" *ngIf="msg.attachmentDataUrl">
        <img *ngIf="isImageAttachment(msg); else fileAttachment" [src]="msg.attachmentDataUrl" [alt]="msg.attachmentName" />
        <ng-template #fileAttachment>
          <a [href]="msg.attachmentDataUrl" [download]="msg.attachmentName">{{ msg.attachmentName || 'Download attachment' }}</a>
        </ng-template>
      </div>

      <div class="manage-members" *ngIf="managingRecipients">
        <mat-form-field appearance="outline">
          <mat-label>Group members</mat-label>
          <mat-select multiple [(value)]="managedRecipientStaffIds">
            <mat-option *ngFor="let s of staffOptions" [value]="s.id">{{ s.fullName }}</mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-flat-button color="primary" (click)="saveRecipients()">Save Group Members</button>
      </div>

      <div class="thread-block">
        <div class="thread-title">Thread Replies ({{ threadCount(msg) }})</div>
        <div class="thread-list" *ngIf="msg.replies?.length; else noReplies">
          <div class="thread-item" *ngFor="let r of msg.replies">
            <div class="thread-item-head">
              <strong>{{ r.senderName }}</strong>
              <span>{{ formatWhen(r.createdAt) }}</span>
            </div>
            <div class="thread-item-body">{{ r.replyText }}</div>
            <div class="attachment-preview compact" *ngIf="r.attachmentDataUrl">
              <img *ngIf="isImageAttachment(r); else replyFileAttachment" [src]="r.attachmentDataUrl" [alt]="r.attachmentName" />
              <ng-template #replyFileAttachment>
                <a [href]="r.attachmentDataUrl" [download]="r.attachmentName">{{ r.attachmentName || 'Download attachment' }}</a>
              </ng-template>
            </div>
          </div>
        </div>
        <ng-template #noReplies>
          <div class="empty-list">No replies yet.</div>
        </ng-template>
      </div>

      <div class="reply-box" *ngIf="canSendMessages()">
        <mat-form-field appearance="outline" class="reply-field">
          <mat-label>{{ msg.isClosed ? 'Thread is closed' : 'Reply to this thread' }}</mat-label>
          <textarea matInput rows="4" [(ngModel)]="replyText" [disabled]="msg.isClosed"></textarea>
        </mat-form-field>
        <div class="attachment-row">
          <label class="file-picker" [class.disabled]="msg.isClosed">
            <mat-icon>attach_file</mat-icon>
            <span>{{ replyAttachment ? replyAttachment.name : 'Attach media/file' }}</span>
            <input type="file" accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx" [disabled]="msg.isClosed" (change)="onAttachmentSelected($event, 'reply')" />
          </label>
          <button mat-button type="button" *ngIf="replyAttachment" (click)="removeAttachment('reply')">Remove</button>
        </div>
        <button mat-flat-button color="primary" (click)="sendReplyInView()" [disabled]="msg.isClosed">Send Reply</button>
      </div>

      <div class="recipient-grid" *ngIf="activeMailbox === 'sent'">
        <h4>Recipients</h4>
        <table class="recipients-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Read</th>
              <th>Last Reply</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of msg.recipients || []">
              <td>{{ r.staffName }}</td>
              <td>{{ r.isRead ? 'Yes' : 'No' }}</td>
              <td>{{ r.replyText || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <ng-template #emptyDetail>
      <section class="conversation-panel empty-conv">
        <div>Select a message to view the conversation.</div>
      </section>
    </ng-template>
  </div>
</div>
